import React from 'react'
import PropTypes from 'prop-types'

import EmailComposer from 'components/App/DesktopView/shared/Composer/Email'

import Editor from './Editor'
import Header from './Header'
import styles from '../shared/styles.css'

class TwitterReply extends React.Component {
  static propTypes = {
    doInitializeDraft: PropTypes.func.isRequired,
    draft: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    doOpenTicketPage: PropTypes.func.isRequired,
    isDM: PropTypes.bool.isRequired,
    isDraftSendable: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired, // is ticket open
    ticketId: PropTypes.string.isRequired,
    updateAndSendDraft: PropTypes.func.isRequired,
  }

  componentDidMount() {
    // A little Janky (TM) but our draft selector does the heavy lifting for
    // fetching saved drafts (in LS or from server) and building a draft object.
    // Rather than try to rewrite this into reducers, we just load the saved
    // draft every time you hit this page. It assumes you have already set up
    // the draftType and default recipients in the _PAGE reducer
    const { doInitializeDraft, ticketId, draft } = this.props
    let draftBody = draft && draft.body
    if (draftBody === ' ') draftBody = null
    const body = draftBody || this.getTwitterUsernamesWithSpace()
    doInitializeDraft(ticketId, {
      ...draft,
      body,
    })
  }

  componentDidUpdate(prevProps) {
    // WARNING!!!
    // For a reason I cannot explain there are cases when the props.ticketId
    // doesnt match props.draft.ticketId. In order to prevent us from initializing
    // a draft on ticket 1 using data from ticket 2, we'll rather just look at
    // the props.draft.ticketId
    if (this.props.draft.ticketId !== prevProps.draft.ticketId) {
      const { doInitializeDraft, ticketId, draft } = this.props
      doInitializeDraft(ticketId, {
        ...draft,
        body: draft.body || this.getTwitterUsernamesWithSpace(),
      })
    }
  }

  getTwitterUsernamesWithSpace() {
    if (this.props.isDM) return null
    const { recipients } = this.props

    const usernames = recipients.map(t => t.twitterHandle)

    return usernames.length > 0 ? `${usernames.join(' ').trim()} ` : null
  }

  startTyping = () => {
    const {
      ticketId,
      doRealtimeAgentStartTicketTypingNotification,
    } = this.props
    doRealtimeAgentStartTicketTypingNotification(ticketId)
  }

  handleDeleteDraft = ticketId => {
    this.props.doOpenTicketPage(ticketId)
  }

  checkIsAgentColliding = () => {
    const { isAgentColliding } = this.props
    if (isAgentColliding) {
      const msg = `Another ${app.t(
        'agent'
      )} is replying. Are you sure you want to send?`
      if (window.confirm(msg)) return true // eslint-disable-line no-alert
    }
    return false
  }

  checkIsUsernameMissingFromBody = (composer, body) => {
    const { isDM, recipients } = this.props
    if (isDM) return false

    const usernames = recipients.map(t => t.twitterHandle)
    const usernamesInBody = usernames.map(un => body.indexOf(un) > -1)
    if (usernamesInBody.some(check => check === false)) {
      const msg = `Unable to send without ${this.getTwitterUsernamesWithSpace()}in the body`
      window.alert(msg) // eslint-disable-line no-alert
      return true
    }
    return false
  }

  // Runs given function if no collision. If collision, pops up confirmation
  // window first.
  checkBeforeSend = (composer, body) => {
    if (this.checkIsAgentColliding()) return false
    if (this.checkIsUsernameMissingFromBody(composer, body)) return false
    return true
  }

  /* Needed to ensure the editor rerenders when we change tickets */
  editorKey = () => {
    return `reply-twitter-editor-ticket-${this.props.draft.ticketId}`
  }

  render() {
    const {
      draft,
      isDM,
      isDraftSendable,
      isOpen,
      isLoadingActions,
      ticketId,
      updateAndSendDraft,
    } = this.props

    if (isLoadingActions) return null

    const header = (
      <Header
        label={isDM ? 'Direct message' : 'Reply to'}
        ticketId={ticketId}
      />
    )

    return (
      <EmailComposer
        className={styles.ReplyForm}
        content={draft.body || this.getTwitterUsernamesWithSpace()}
        draft={draft}
        editor={Editor}
        header={header}
        isDraftSendable={isDraftSendable}
        isOpen={isOpen}
        onBeforeSend={this.checkBeforeSend}
        onBodyChange={this.startTyping}
        onDeleteDraft={this.handleDeleteDraft}
        showCharCount={!isDM}
        ticketId={ticketId}
        updateAndSendDraft={updateAndSendDraft}
      />
    )
  }
}

export default TwitterReply
